import $ from 'jquery'
import preact from 'preact'
import HappyFace from '../../preact-components/topic-helpfulness/assets/happy.js'
import ConfusedFace from '../../preact-components/topic-helpfulness/assets/confused.js'
import WearyFace from '../../preact-components/topic-helpfulness/assets/weary.js'

class ContentHelpfulnessPerformance extends preact.Component {
  constructor () {
    super()
    this.state = {
      helpfulnessScore: {},
      isVisible: false
    }
  }

  componentDidMount () {
    $.get('/helpfulness/performanceWidget', {
      'topicId': this.props.topicId
    }).then(function (data) {
      if (!data.score) {
        return
      }

      const total = Object.keys(data.score).reduce(function (result, options) {
        return result + parseInt(data.score[options])
      }, 0)

      const percentage = total !== 0 ? Math.round(data.score.helpful / total * 100) : 0

      this.setState({
        helpfulnessScore: data.score,
        isVisible: Object.keys(data.score).length > 0,
        percentage: percentage,
        color: this.getColor(percentage)
      })
    }.bind(this))
  }

  getColor (percentage) {
    if (percentage < 40) {
      return 'red'
    } else if (percentage < 70) {
      return 'orange'
    } else {
      return 'green'
    }
  }

  render (props, state) {
    if (!state.isVisible) return

    let { helpful, neutral, nothelpful } = state.helpfulnessScore

    return (
      <div className='panel panel-default content-helpfulness_performance-wrapper'>
        <div className='panel-heading'>
          <h3 className='panel-title'>Content helpfulness performance</h3>
        </div>

        <div className='panel-body content-helpfulness_performance-body'>
          <span className={`content-helpfulness_performance-score ${state.color}`} data-score={state.percentage}>Score {state.percentage}%</span>
          <span className='topic-helpfulness_performance-options'>
            <HappyFace />
            <span className='content-helpfulness_performance-number qa-topic-helpful'>{helpful}</span>
          </span>
          <span className='topic-helpfulness_performance-options'>
            <ConfusedFace />
            <span className='content-helpfulness_performance-number qa-topic-neutral'>{neutral}</span>
          </span>
          <span className='topic-helpfulness_performance-options'>
            <WearyFace />
            <span className='content-helpfulness_performance-number qa-topic-notHelpful'>{nothelpful}</span>
          </span>
        </div>
      </div>
    )
  }
}

export default ContentHelpfulnessPerformance
